const ABOUT_US = "/about-us";

const ROUTES = {
  // Auth Routes:::
  LOGIN: "/login",

  // Public Routes:::
  HOME: "/",
  ABOUT_US,
  ABOUT_FUJAIRAH: `${ABOUT_US}/about-fujairah`,
  ABOUT_FUJAIRAH_FREEZONE: `${ABOUT_US}/about-fujairah-freezone`,
  START_YOUR_BUSINESS: "/start-your-business",
  OUR_SERVICES: "/our-services",
  MEDIA_CENTER: "/media-center",
  NEWS_AND_EVENTS: "/news-and-events",
  INVESTORS_CORNER: "/investors-corner",
  CONTACT_US: "/contact-us",
  FAQs: "/faqs",
  PRIVACY_POLICY: "/privacy-and-quality-policy",
  REGISTRATION_PROCESS: "/registration-process",
  AML_CTF_LAWS: "/aml-or-ctf-laws",
  FUJAIRAH_PARTNERS: "/fujairah-partners",
  OPEN_DATA: "/open-data",

  COURSES: "/categories",
  CAREERS: "/career",
  OFFERS: "/offers",
  CANCELLATION_POLICY: "/cancellation-policy",
  NOT_FOUND: "/not-found",

  // Admin Routes:::
  ADMIN_PROFILE: "/admin/profile-info",

  ADMIN_DASHBOARD_ECOMMERCE: "/admin/dashboard",

  // NOTIFICATION:::
  ADMIN_ALL_NOTIFICATIONS: "/admin/notification/view",
  ADMIN_CREATE_NOTIFICATION: "/admin/notification/create",
  ADMIN_UPDATE_NOTIFICATION: `/admin/notification/update`,

  // COMPANY LISTING:::
  ADMIN_ALL_COMAPNY_LISTING: "/admin/company/view",
  ADMIN_CREATE_COMPANY: "/admin/company/create",
  ADMIN_UPDATE_COMPANY: `/admin/company/update`,

  // MEDIA CENTER:::
  // PHOTO
  ADMIN_ALL_PHOTOS: "/admin/media/photo/view",
  ADMIN_CREATE_PHOTO: "/admin/media/photo/create",
  ADMIN_UPDATE_PHOTO: "/admin/media/photo/update",
  // VIDEO
  ADMIN_ALL_VIDEOS: "/admin/media/video/view",
  ADMIN_CREATE_VIDEO: "/admin/media/video/create",
  ADMIN_UPDATE_VIDEO: "/admin/media/video/update",
  // MOVIE
  ADMIN_ALL_MOVIES: "/admin/media/movie/view",
  ADMIN_CREATE_MOVIE: "/admin/media/movie/create",
  ADMIN_UPDATE_MOVIE: "/admin/media/movie/update",

  // FAQ Routes:::
  ADMIN_ALL_FAQS: "/admin/faq/management/view",
  ADMIN_CREATE_FAQ: "/admin/faq/management/create",
  ADMIN_UPDATE_FAQ: "/admin/faq/management/update",

  // FAQ Category Routes:::
  ADMIN_ALL_FAQ_CATEGORIES: "/admin/faq/category/view",
  ADMIN_CREATE_FAQ_CATEGORY: "/admin/faq/category/create",
  ADMIN_UPDATE_FAQ_CATEGORY: "/admin/faq/category/update",

  // Investment Routes:::
  ADMIN_ALL_INVESTMENTS: "/admin/investment/view",
  ADMIN_CREATE_INVESTMENT: "/admin/investment/create?tab=section-1",
  ADMIN_UPDATE_INVESTMENT: `/admin/investment/update`,

  // Service Routes:::
  ADMIN_ALL_SERVICES: "/admin/service/view",
  ADMIN_CREATE_SERVICE: "/admin/service/create?tab=section-1",
  ADMIN_UPDATE_SERVICE: `/admin/service/update`,

  // News Article Routes
  ADMIN_ALL_NEWS_ARTICLES: "/admin/news/article/view",
  ADMIN_CREATE_NEWS_ARTICLE: "/admin/news/article/create",
  ADMIN_UPDATE_NEWS_ARTICLE: `/admin/news/article/update`,

  // News Category Routes
  ADMIN_ALL_NEWS_CATEGORIES: "/admin/news/category/view",
  ADMIN_CREATE_NEWS_CATEGORY: "/admin/news/category/create",
  ADMIN_UPDATE_NEWS_CATEGORY: (targetId) =>
    `/admin/news/category/update/${targetId}`,

  // Contact Routes
  ADMIN_ALL_CONTACTS: "/admin/contact/view",
  ADMIN_CREATE_CONTACT: "/admin/contact/create",
  ADMIN_ALL_CONTACT_QUERIES: "/admin/contact/queries",
  ADMIN_UPDATE_CONTACT: (targetId) => `/admin/contact/update/${targetId}`,

  // Testimonial Routes
  ADMIN_ALL_TESTIMONIALS: "/admin/testimonial/view",
  ADMIN_CREATE_TESTIMONIAL: "/admin/testimonial/create",
  ADMIN_UPDATE_TESTIMONIAL: `/admin/testimonial/update`,

  // Career Routes
  ADMIN_ALL_CAREERS: "/admin/career/view",
  ADMIN_CREATE_CAREER: "/admin/career/create",
  ADMIN_UPDATE_CAREER: "/admin/career/update",

  // Courses Routes
  ADMIN_ALL_COURSES: "/admin/training-courses/view",
  ADMIN_CREATE_COURSE: "/admin/training-courses/create?tab=section-1",
  ADMIN_UPDATE_COURSE: (slug) => `/admin/training-courses/update/${slug}`,

  // Courses Package Routes
  ADMIN_ALL_COURSE_PACKAGES: "/admin/training-courses/package/view",
  ADMIN_CREATE_COURSE_PACKAGE: "/admin/training-courses/package/create",
  ADMIN_UPDATE_COURSE_PACKAGE: (targetId) =>
    `/admin/training-courses/package/update/${targetId}`,

  // File Routes
  ADMIN_ALL_FILES: "/admin/files/view",
  ADMIN_CREATE_FILE: "/admin/files/create",

  // Menu Management Routes
  ADMIN_MENU_LISTS: "/admin/menu/view",
  ADMIN_ADD_NEW_MENU: "/admin/menu/create",
  ADMIN_EDIT_MENU: (targetId) => `/admin/menu/update/${targetId}`,

  // Staff Management Routes
  ADMIN_ALL_STAFF: "/admin/staff/view",
  ADMIN_STAFF_UPDATE: (targetId) => `/admin/staff/update/${targetId}`,

  ADMIN_STAFF_ALL_ROLES: "/admin/staff/role/view",
  ADMIN_STAFF_CREATE_ROLE: "/admin/staff/role/create",
  ADMIN_STAFF_UPDATE_ROLE: (roleId) => `/admin/staff/role/update/${roleId}`,

  // Language Management Routes
  ADMIN_ALL_LANGUAGES: "/admin/configurations/language/view",
  ADMIN_CREATE_LANGUAGE: "/admin/configurations/language/create",
  ADMIN_UPDATE_LANGUAGE: (targetId) =>
    `/admin/configurations/language/update/${targetId}`,

  // CMS Setup Routes
  ADMIN_CMS_ALL_PAGES: "/admin/pages-setup/view",
  ADMIN_CMS_CREATE_PAGE: "/admin/pages-setup/create",
  ADMIN_CMS_UPDATE_PAGE: (linkId) => `/admin/pages-setup/update/${linkId}`,
  ADMIN_CMS_UPDATE_PAGE_SECTIONS: (linkId) =>
    `/admin/pages-setup/sections/${linkId}`,

  // Setup Management Routes
  ADMIN_WEBSITE_APPEARANCE_SETUP: "/admin/configurations/appearance",
  ADMIN_WEBSITE_FOOTER_SETUP: "/admin/configurations/footer",

  // Inquires Center Routes
  ADMIN_ALL_GENERAL_INQUIRIES: "/admin/inquires/general",
  ADMIN_ALL_BUSINESS_INQUIRIES: "/admin/inquires/business",
  ADMIN_ALL_SERVICE_INQUIRIES: "/admin/inquires/service",
  ADMIN_ALL_BUSINESS_CLUB_INQUIRIES: "/admin/inquires/business-club",
  ADMIN_ALL_CAREER_INQUIRIES: "/admin/inquires/career",
  ADMIN_ALL_PARTNERSHIP_INQUIRIES: "/admin/inquires/partnership",
  ADMIN_ALL_CONSULTING_INQUIRIES: "/admin/inquires/consulting",
};

export default ROUTES;
